import React, { useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { url_action } from "../../Redux/URLAction";
import SpinnerLoader from "../../webLoader/SpinnerLoader";
import commonApi from "../../CommonApi/CommonServices";
import { errorMessage } from "../../Errors/Toast";

const StripeSubscriptionForm = (props) => {
  const userSelectPkg = useSelector((state) => state.payment_reducer?.data);
  const stripe = useStripe();
  const elements = useElements();
  const [showLoader, setShowLoader] = useState(false);
  const token = useSelector((state) => state.rootReducer?.user?.token);
  const dispatch = useDispatch();
  const location = useLocation();

  const handleSubmit = async (event) => {
    event.preventDefault();
    dispatch(url_action(location.pathname));

    if (!stripe || !elements) return;

    const { error: submitError } = await elements.submit();
    if (submitError) return;

    setShowLoader(true);

    try {
      const host = window.location.origin;
      // const returnUrl = `${host}/payment`;

      const { error, paymentIntent } = await stripe.confirmPayment({
        elements,
        // confirmParams: {
        //   // return_url: returnUrl,
        // },
        redirect: "if_required",
      });

      if (error) {
        errorMessage(error.message || "Payment failed.");
        setShowLoader(false);
        props.onClose("failed");
      } else if (paymentIntent && paymentIntent.status === "succeeded") {
        props.onClose("success");
      }
    } catch (err) {
      console.error(err);
      errorMessage("An unexpected error occurred.");
    } finally {
      setShowLoader(false);
    }
  };

  const cardStyle = {
    style: {
      base: {
        color: "#32325d",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4",
        },
        ":focus": {
          border: "none",
          outline: "none",
          boxShadow: "none",
        },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    },
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="payment-from">
          <PaymentElement options={cardStyle} />
          {!showLoader && (
            <button
              className="submit_button"
              type="submit"
              disabled={!stripe || !elements}
            >
              Submit
            </button>
          )}
        </div>
        {showLoader && <SpinnerLoader color={"#fff"} />}
      </form>
    </div>
  );
};
export default StripeSubscriptionForm;
